import React from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import runes from 'runes';

import './Header.scss';
import { urlFormatter, isMobile, useWindowSize } from '../../../util';
import Logo from './Logo';
import HeaderNav from './HeaderNav';
import { initiateUser } from 'services/user.service';
import Translation from 'services/translation.service';
import UserMenu from './user_menu';
import { KEY_ENTER_BUTTON } from '../../../constants';
import MenuFooter from './MenuFooter';
import rechargeIcon from '../../../assets/img/recharge.svg';
import { setLayoutConfigrations } from '../../../stores/Layout/layoutActions';
import { bindActionCreators } from 'redux';
import { useEffect } from 'react';
import Search from '../search';
import RequirePermission from '../RequirePermission';
import * as constants from '../../../constants';

const Header = React.memo((props) => {
  const [width, height] = useWindowSize();
  useEffect(() => {
    if (!isMobile()) hideSideMenu();
  }, [width, height]);
  const [mobileMenu, showMobileMenu] = React.useState(false);
  const [showResults, setShowResults] = React.useState(false);
  const [searchKey, setSearchKey] = React.useState(null);
  const [showMenu, updateShowMenu] = React.useState(false);
  const { bundleRedirect } = useSelector((state) => state.layout);
  const {
    loggedIn,
    links,
    mobile,
    selectedSubscriber,
    translation,
    lang,
    setLayoutConfigrations,
  } = props;
  const subscriptionType = useSelector(
    (state) => state.dashboard.subscriptionType
  );
  const lineType = useSelector(
    (state) => state.dashboard?.proprties?.line_type
  );

  const hideSideMenu = React.useCallback(() => {
    if (mobileMenu || showMenu) {
      document.body.classList.remove('overflow');
      showMobileMenu(false);
      updateShowMenu(false);
    }
  }, [mobileMenu, showMenu]);
  ////////////////////////////////
  const toggleSideMenu = React.useCallback(() => {
    showMobileMenu((showMenu) => {
      if (showMenu) {
        document.body.classList.remove('overflow');
      } else {
        document.body.classList.add('overflow');
      }
      return !showMenu;
    });
  }, []);
  ////////////////////////////////
  const fullName = React.useMemo(() => {
    let name = '';
    if (selectedSubscriber) {
      // name = `${selectedSubscriber.user.first_name} ${selectedSubscriber.user.last_name}`.trim();
      name = `${selectedSubscriber.nickname}`.trim();
      return name ? name : selectedSubscriber.user.mobile_number;
    }
    // else if (firstName && lastName) {
    //   name = `${firstName} ${lastName}`.trim();
    //   return name ? name : mobile;
    // }
    return name;
  }, [selectedSubscriber, mobile]);
  ////////////////////////////////
  const mobileNumber = React.useMemo(() => {
    return selectedSubscriber ? selectedSubscriber.user.mobile_number : mobile;
  }, [selectedSubscriber, mobile]);
  ////////////////////////////////

  let desktopAuthLink = null;
  const loginLink =
    urlFormatter(links?.['informative-login']?.['route']) ||
    urlFormatter(links?.['informative-login']?.[1]?.['route']);
  const dashboardLink = urlFormatter(links?.['wsc-dashboard-usage']?.['route']);
  desktopAuthLink = (
    <li className="nav-list-itm user-menu-desktop" style={{ padding: 0 }}>
      <div className="userDataMenuLabel pointer">
        {loggedIn ? (
          <Link
            to={isMobile() ? dashboardLink : ''}
            className="lebara-button small"
          >
            {(isMobile()
              ? ''
              : Translation.key('generic_lbl1.0_otp_hi') + ' ') +
              (fullName.trim() && fullName.length <= 15
                ? fullName
                : fullName.trim() && fullName.length >= 15
                ? runes.substr(fullName, 0, 10) + '...'
                : 'User')}
          </Link>
        ) : (
          <Link to={loginLink} className="lebara-button small">
            {Translation.key('generic_login_tab1.1_login')}{' '}
          </Link>
        )}
      </div>
      <UserMenu show={showMenu} mobile={mobileNumber} />
    </li>
  );
  // }

  ////////////////////////////////
  const searchResults = (e) => {
    e.preventDefault();
    setShowResults(true);
    hideSideMenu();
  };
  ////////////////////////////////
  const handleInput = (event) => {
    var text = event.target.value;
    setSearchKey(text);
  };
  ////////////////////////////////
  const onKeyPress = (event) => {
    if (event.key === KEY_ENTER_BUTTON) {
      if (searchKey) {
        searchResults();
      }
    }
  };
  ////////////////////////////////
  // const headerNav = React.useMemo(
  //   () => <HeaderNav toggleSideMenu={hideSideMenu} />,
  //   [hideSideMenu]
  // );
  const headerNav = (
    <HeaderNav
      changeLang={() => changeLang(switchLanguageTo)}
      changeLangMobile={(lang) => changeLangMobile(lang)}
      toggleSideMenu={hideSideMenu}
    />
  );
  ////////////////////////////////

  const headerMobileClasses = ['header-mobile'];

  if (mobileMenu) {
    headerMobileClasses.push('opened');
  }

  if (showResults) {
    const searchResultLink = urlFormatter(
      `/${props.links['informative-search_results']['route']}`
    );
    const searchResultLinkWithoutKey = searchResultLink.split(':key');
    setShowResults(false);
    props.history.push(searchResultLinkWithoutKey[0] + searchKey, {
      comingFrom: 'Header',
    });
  }

  const authLinksClasses = ['login-register-links'];
  if (loggedIn && isMobile()) {
    authLinksClasses.push('hide-login-register-links');
  }

  let complaint_link = '';
  let stores_link = '';
  let careers_link = '';
  let business_link = '';
  let push_to_talk_link = '';
  let online_recharge = '';

  if (links) {
    complaint_link = urlFormatter(
      links['informative-customer_complaints']['route']
    );
    stores_link = urlFormatter(links['informative-stores']['route']);
    careers_link = urlFormatter(links['informative-careers']['route']);
    business_link = urlFormatter(links['informative-business']['route']);
    push_to_talk_link = urlFormatter(
      links['informative-push_to_talk']['route']
    );
    online_recharge = urlFormatter(
      links['informative-online_recharge']['route']
    );
  }
  const changeLang = (lang) => {
    const newPath = props.location.pathname.replace(/\/(en|ar)/, `/${lang}`);
    props.history.push(newPath, { comingFrom: 'Header' });
    window.appLang = lang;
    setLayoutConfigrations(lang, props.location.state);
    if (loggedIn) initiateUser();
    // props.history.push('/en/ssss')
    hideSideMenu();
  };

  const changeLangMobile = (lang) => {
    window.appLang = lang;
    setLayoutConfigrations(lang, props.location.state);
    hideSideMenu();
  };

  let numberBookingLink = urlFormatter(
    links?.['shop-join_lebara-select_number']?.['route']
  );
  let packgeCategoryLink = urlFormatter(
    links?.['shop-join_lebara-voice_plans']?.['route']
  );
  const switchLanguageTo = lang === 'ar' ? 'en' : 'ar';

  return (
    <header id="header">
      <div className="header-style">
        <div className="container">
          <div className="flex-between full-height-desktop">
            <div
              className="burger"
              onClick={() => {
                initiateUser();
                toggleSideMenu();
              }}
            >
              <i className="burger-sep"></i>
            </div>
            {isMobile() ? (
              <>
                {desktopAuthLink}
                {subscriptionType != constants.SUBSCRIPER_TYPE_POSTPAID &&
                  lineType != constants.LINE_TYPE_DATA && (
                    <>
                      {' '}
                      <RequirePermission permission="recharge">
                        <Link
                          className="lebara-button primary small mobile-only"
                          to={online_recharge}
                        >
                          <img src={rechargeIcon} />
                        </Link>
                      </RequirePermission>
                      <RequirePermission permission="recharge">
                        <Link
                          className="lebara-button primary small tablet-desktop-only"
                          to={online_recharge}
                        >
                          <img
                            src={rechargeIcon}
                            alt={Translation.key('lws_or_key')}
                          />
                          &nbsp;{Translation.key('lws_or_key')}
                        </Link>
                      </RequirePermission>
                    </>
                  )}
              </>
            ) : (
              <Logo hideSideMenu={hideSideMenu} />
            )}

            <nav className={headerMobileClasses.join(' ')} id="header-mobile">
              <div
                className="burger opened mobile-tablet-only"
                onClick={toggleSideMenu}
              >
                <i className="burger-sep"></i>
              </div>
              <div className="header-mobile-wrapper">
                <span className="header-scrollable">
                  <div className="search-header-wrapper mobile-only">
                    <form
                      className="search-input-wrapper"
                      onSubmit={searchResults}
                    >
                      <input
                        type="submit"
                        value="search"
                        className="search-btn"
                      />
                      <input
                        type="text"
                        placeholder={Translation.key('generic_inpt_search')}
                        className="search-input"
                        autoComplete="false"
                        onChange={(event) => handleInput(event)}
                        onKeyPress={(event) => onKeyPress(event)}
                      />
                    </form>
                  </div>

                  {/* <div>
                      <div className="list-box-container mobile-tablet-only">
                        <Link
                          className="list-box"
                          to={`${packgeCategoryLink}?category=prepaid`}
                          onClick={toggleSideMenu}
                          style={{
                            background:
                              'linear-gradient(307.04deg, #00AAEB 16.9%, #3824D6 90.84%)',
                          }}
                        >
                          {Translation.key('prepaid_plans')}
                        </Link>
                        <Link
                          className="list-box"
                          to={`${packgeCategoryLink}?category=postpaid`}
                          onClick={toggleSideMenu}
                          style={{
                            background:
                              'linear-gradient(298.62deg, #FF317C 0%, #1A1F45 121.22%)',
                          }}
                        >
                          {Translation.key('postpaid_plans')}
                        </Link>
                      </div>
                      <div className="list-box-container mobile-tablet-only">
                        <Link
                          className="list-box"
                          to={numberBookingLink}
                          onClick={toggleSideMenu}
                          style={{
                            background:
                              'linear-gradient(298.62deg, #00A6EB 0%, #1A1F45 121.22%)',
                          }}
                        >
                          {Translation.key('lebara_numbers')}
                        </Link>
                      </div>
                    </div> */}

                  {headerNav}
                  <MenuFooter hideSideMenu={hideSideMenu} />
                </span>
              </div>
            </nav>
          </div>

          <div className="flex-column-end" style={{ height: '100%' }}>
            <div className="topBar">
              <div className="float-right-top">
                <ul style={{ margin: '0' }}>
                  <li className="dropdown">
                    <span>{Translation.key('b2b_business')}</span>
                    <ul className="dropdown-list">
                      <li>
                        <Link onClick={hideSideMenu} to={business_link}>
                          {Translation.key('business_plans_header_title')}
                        </Link>
                      </li>
                      <li>
                        <Link onClick={hideSideMenu} to={push_to_talk_link}>
                          {Translation.key('push_to_talk_header_title')}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link onClick={hideSideMenu} to={complaint_link}>
                      {Translation.key('Complaints')}
                    </Link>
                  </li>
                  {/* <li>
                    <Link onClick={hideSideMenu} to={stores_link}>
                      {Translation.key('shop_finder')}
                    </Link>
                  </li> */}
                  <li>
                    <a onClick={() => changeLang(switchLanguageTo)}>
                      {Translation.key('switch_language_label')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="flex-end"
              style={{ maxHeight: '38px', gap: '10px' }}
            >
              {isMobile() ? (
                <Logo hideSideMenu={hideSideMenu} />
              ) : (
                <>
                  {subscriptionType != constants.SUBSCRIPER_TYPE_POSTPAID &&
                    lineType != constants.LINE_TYPE_DATA && (
                      <RequirePermission permission="recharge">
                        <Link
                          className="lebara-button primary small tablet-desktop-only"
                          to={online_recharge}
                        >
                          <img
                            src={rechargeIcon}
                            alt={Translation.key('lws_or_key')}
                          />
                          &nbsp;{Translation.key('lws_or_key')}
                        </Link>
                      </RequirePermission>
                    )}
                  {desktopAuthLink}
                </>
              )}
              {isMobile() ? '' : <Search />}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
});

const mapStateToProps = (state) => {
  return {
    loggedIn: state.user.loggedIn,
    lang: state.layout.iso,
    translation: state.layout.translation,
    links: state.layout.routes,
    userInfo: state.user.userInfo,

    mobile: state.user.mobile_number,
    selectedSubscriber: state.user.selectedSubscriber,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setLayoutConfigrations }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
